export default function IconScaleVertical({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <g id="Scale-Vertical Streamline Ultimate">
        <path
          id="Vector"
          d="M0.375 10.0781C0.375 11.5078 0.942939 12.8789 1.95388 13.8899C2.96482 14.9008 4.33594 15.4687 5.76562 15.4688C7.19531 15.4687 8.56643 14.9008 9.57737 13.8899C10.5883 12.8789 11.1562 11.5078 11.1562 10.0781C11.1562 8.64844 10.5883 7.27732 9.57737 6.26638C8.56643 5.25544 7.19531 4.6875 5.76562 4.6875C4.33594 4.6875 2.96482 5.25544 1.95388 6.26638C0.942939 7.27732 0.375 8.64844 0.375 10.0781Z"
          fill="#FFFBEB"
        />
        <path
          id="Vector_2"
          d="M0.734375 6.48438V5.04688C0.734375 4.85625 0.8101 4.67343 0.944892 4.53864C1.07968 4.40385 1.2625 4.32813 1.45312 4.32812H10.0781C10.2687 4.32812 10.4516 4.40385 10.5864 4.53864C10.7211 4.67343 10.7969 4.85625 10.7969 5.04688V6.48438"
          stroke="#B45309"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M5.76562 4.32669V15.8267"
          stroke="#B45309"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M3.25 15.8267H8.28125"
          stroke="#B45309"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_5"
          d="M15.1094 1.45169V17.2642"
          stroke="#B45309"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_6"
          d="M12.9531 4.32669L15.1094 1.45169L17.2656 4.32669"
          stroke="#B45309"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_7"
          d="M12.9531 14.3892L15.1094 17.2642L17.2656 14.3892"
          stroke="#B45309"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
